import React, { useState } from 'react';
import PropTypes from 'prop-types';


const chocolateChunkImage = require("./imgs/chocolate-chunk.png");
const cookiesNCreamImage = require("./imgs/cookies-n-cream.png");
const snickerdoodleImage = require("./imgs/snickerdoodle.png");
const doubleChocolateChunkImage = require("./imgs/double-chocolate-chunk.png");
const sugarImage = require("./imgs/sugar.png");
const whiteChocolateMacadamiaImage = require("./imgs/white-chocolate-macadamia.png");
const peanutButterChipImage = require("./imgs/peanut-butter-chip.png");
const classicWithMMsImage = require("./imgs/classic-with-m-ms.png");
const oatmealRaisinImage = require("./imgs/oatmeal-raisin.png");
const doubleChocolateMintImage = require("./imgs/double-chocolate-mint.png");
const veganBirthdayCakeImage = require("./imgs/vegan-birthday-cake.png");
const veganChocolateChunkImage = require("./imgs/vegan-chocolate-chunk.png");
const veganDoubleChocolateChunkImage = require("./imgs/vegan-double-chocolate-chunk.png");
const veganGlutenFreeChocolateChunkImage = require("./imgs/vegan-gluten-free-chocolate-chunk.png");
const chocolatePeanutButterCupDeluxeImage = require("./imgs/chocolate-peanut-butter-cup-deluxe.png");
const smoresDeluxeImage = require("./imgs/smores-deluxe.png");
const saltedCaramelDeluxeImage = require("./imgs/salted-caramel-deluxe.png");
const confettiDeluxeImage = require("./imgs/confetti-deluxe.png");
const tripleChocolateDeluxeImage = require("./imgs/triple-chocolate-deluxe.png");
const oatmealChocolateWalnutDeluxeImage = require("./imgs/oatmeal-chocolate-walnut-deluxe.png");
const chocolateChipBrownieImage = require("./imgs/chocolate-chip-brownie.png");
const chocolateChunkBrookieImage = require("./imgs/chocolate-chunk-brookie.png");
const chocolateChunkBlondieImage = require("./imgs/chocolate-chunk-blondie.png");



const Product = ({
  formData,
  onFormDataChange,
  onNext,
  onBack,
}) => {
  const [products, setProducts] = useState(formData.products || {});
  const [additionalProductRequests, setAdditionalProductRequests] = useState(formData.additionalProductRequests || '');
  const [waxBags, setWaxBags] = useState(formData.waxBags || false);
  const [cellophaneBags, setCellophaneBags] = useState(formData.cellophaneBags || false);
  const [assortment, setAssortment] = useState(formData.assortment|| false);
  const [iceCream, setIceCream] = useState(formData.iceCream || false);
  const [iceCreamDescription, setIceCreamDescription] = useState(formData.iceCreamDescription || '');
  const [errorMessage, setErrorMessage] = useState('');

  const cookieTypes = [
    { id: 'chocolate-chunk', name: 'Chocolate Chunk', image: chocolateChunkImage },
    { id: 'cookies-n-cream', name: "Cookies 'N Cream", image: cookiesNCreamImage },
    { id: 'snickerdoodle', name: 'Snickerdoodle', image: snickerdoodleImage },
    { id: 'double-chocolate-chunk', name: 'Double Chocolate Chunk', image: doubleChocolateChunkImage },
    { id: 'sugar', name: 'Sugar', image: sugarImage },
    { id: 'white-chocolate-macadamia', name: 'White Chocolate Macadamia', image: whiteChocolateMacadamiaImage },
    { id: 'peanut-butter-chip', name: 'Peanut Butter Chip', image: peanutButterChipImage },
    { id: 'classic-with-m-ms', name: 'Classic with M&Ms', image: classicWithMMsImage },
    { id: 'oatmeal-raisin', name: 'Oatmeal Raisin', image: oatmealRaisinImage },
    { id: 'double-chocolate-mint', name: 'Double Chocolate Mint', image: doubleChocolateMintImage },
    { id: 'vegan-birthday-cake', name: 'Vegan Birthday Cake', image: veganBirthdayCakeImage },
    { id: 'vegan-chocolate-chunk', name: 'Vegan Chocolate Chunk', image: veganChocolateChunkImage },
    { id: 'vegan-double-chocolate-chunk', name: 'Vegan Double Chocolate Chunk', image: veganDoubleChocolateChunkImage },
    { id: 'vegan-gluten-free-chocolate-chunk', name: 'Vegan Gluten Free Chocolate Chunk', image: veganGlutenFreeChocolateChunkImage },
    { id: 'chocolate-peanut-butter-cup-deluxe', name: 'Chocolate Peanut Butter Cup Deluxe', image: chocolatePeanutButterCupDeluxeImage },
    { id: 'smores-deluxe', name: "S'mores Deluxe", image: smoresDeluxeImage },
    { id: 'salted-caramel-deluxe', name: 'Salted Caramel Deluxe', image: saltedCaramelDeluxeImage },
    { id: 'confetti-deluxe', name: 'Confetti Deluxe', image: confettiDeluxeImage },
    { id: 'triple-chocolate-deluxe', name: 'Triple Chocolate Deluxe', image: tripleChocolateDeluxeImage },
    { id: 'oatmeal-chocolate-walnut-deluxe', name: 'Oatmeal Chocolate Walnut Deluxe', image: oatmealChocolateWalnutDeluxeImage },
    { id: 'chocolate-chip-brownie', name: 'Chocolate Chip Brownie', image: chocolateChipBrownieImage },
    { id: 'chocolate-chunk-brookie', name: 'Chocolate Chunk Brookie', image: chocolateChunkBrookieImage },
    { id: 'chocolate-chunk-blondie', name: 'Chocolate Chunk Blondie', image: chocolateChunkBlondieImage }
  ];


  const handleProductChange = (cookieId, name, quantity) => {
    const selectedProducts = { ...products };
    if (quantity === 0) {
      delete selectedProducts[cookieId];
    } else {
      selectedProducts[cookieId] = {
        name,
        quantity: parseInt(quantity, 10)
      };
    }
    setProducts(selectedProducts);
  };

  const handleWaxBagsChange = (checked) => {
    setWaxBags(checked);
  };

  const handleCellophaneBagsChange = (checked) => {
    setCellophaneBags(checked);
  };

  const handleAssortmentChange = (selected) => {
    setAssortment(selected);
    if (selected) {
      // Clear individual cookie selections when assortment is selected
      setProducts({});

    }
  };

  const handleIceCreamChange = (checked) => {
    setIceCream(checked);
    if (!checked) {
      // Clear description when ice cream is unchecked
      setIceCreamDescription('');
    }
  };

  const handleAdditionalProductRequestsChange = (value) => {
    setAdditionalProductRequests(value);
  };

  const handleIceCreamDescriptionChange = (value) => {
    setIceCreamDescription(value);
  };

  const calculateTotal = () => {
    let totalCookies = 0;

    if (assortment) {
      // If assortment is selected, assume a standard assortment quantity
      totalCookies = 1; // This represents "one assortment"
    } else {
      Object.entries(products).forEach(([, {quantity}]) => {
        if (quantity > 0) {
          totalCookies += quantity;
        }
      });
    }

    return { totalCookies };
  };

  const { totalCookies } = calculateTotal();

  const handleNext = () => {
    setErrorMessage('');
    if (totalCookies === 0) {
      setErrorMessage('Please select at least one cookie');
      return;
    }

    // Update form data with all current step data before moving to next step
    onFormDataChange({
      products,
      additionalProductRequests,
      waxBags,
      cellophaneBags,
      assortment,
      iceCream,
      iceCreamDescription
    });

    onNext();
  };

  return (
    <div className="pt-3">

      {/* Assortment Button */}
      <div className="mb-6">
        <button
          type="button"
          className={`
            w-full py-3 px-4 rounded-lg font-bold font-montserratBold text-base transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98]
            ${assortment
              ? 'bg-[#E01766] text-white shadow-lg border-2 border-[#E01766]'
              : 'bg-[#5A3770] text-white border-2 border-[#5A3770] hover:bg-[#E01766] hover:border-[#E01766] hover:shadow-md'
            }
          `}
          onClick={() => handleAssortmentChange(!assortment)}
        >
          <div className="flex items-center justify-center gap-2">
            {assortment ? (
              <>
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span>Assortment of Most Popular Cookies Selected</span>
              </>
            ) : (
              <>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4" />
                </svg>
                <span>Pick for Me</span>
              </>
            )}
          </div>
        </button>
      </div>

      <h2 className="text-lg font-semibold text-white mb-3 font-montserratBold">
        Enter Cookie Amount
      </h2>

      <div className={`mb-8 ${assortment ? 'opacity-50 pointer-events-none' : ''}`}>
        {cookieTypes.map((cookie) => (
          <div key={cookie.id} className="flex items-center py-1 border-b border-[#5A3770] md:min-h-[88px] gap-2">
            <div className="w-[56px] h-[56px] md:w-20 md:h-20 flex-shrink-0">
              <img
                src={cookie.image}
                height={80}
                width={80}
                alt={cookie.name}
                className="w-full h-full object-contain rounded-lg"
              />
            </div>
            <div className="flex-1 flex items-start gap-0 justify-start flex-col">
              <h3 className="text-base font-bold font-montserratBold text-white leading-[18px]">
                {cookie.name}
              </h3>
            </div>
            <div className="flex items-center gap-2 custom-input-field-wrapper">
              <input
                type="number"
                data-testid={`quantity-input-${cookie.id}`}
                className="w-[106px] h-11 border border-[#5A3770] rounded-full text-center text-2xl font-bold font-montserratBold text-white bg-[#4D295C] focus:outline-[0] focus:ring-0 appearance-none"
                value={products[cookie.id]?.['quantity'] || ''}
                onChange={(e) => handleProductChange(cookie.id, cookie.name, parseInt(e.target.value, 10) || 0)}
                min="0"
                disabled={assortment}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 mb-4 ml-3">
        <textarea
          id="additionalProductRequests"
          name="additionalProductRequests"
          className="w-full h-24 mt-2 px-4 py-3 border border-[#5A3770] rounded-lg bg-[#2C0C37] text-white placeholder-[#B4A5BB] focus:outline-none focus:ring-2 focus:ring-[#E01766] focus:border-transparent resize-none"
          placeholder="Please include any additional product requests such as Limited Time Cookies."
          value={additionalProductRequests}
          onChange={(e) => handleAdditionalProductRequestsChange(e.target.value)}
        />
      </div>

      <div className="mb-8">
        <div className="flex items-center mb-4 justify-between gap-4">
          <span className="ml-3 text-white flex flex-col">
            <span className="text-base font-bold font-montserratBold">Ind. Wrapped in Wax Bags </span>
          </span>
          <label htmlFor="waxBagsLabel" className="flex items-center cursor-pointer">
            <input
              id="waxBagsLabel"
              data-testid="wax-bags-toggle"
              type="checkbox"
              className="sr-only"
              checked={waxBags}
              onChange={(e) => handleWaxBagsChange(e.target.checked)}
            />
            <div className={`
              relative w-12 h-6 rounded-full transition-colors duration-300
              ${waxBags ? 'bg-[#E01766]' : 'bg-[#800e3c]'}
            `}
            >
              <div className={`
                absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform duration-300
                ${waxBags ? 'translate-x-6' : 'translate-x-0'}
              `}
              />
            </div>
          </label>
        </div>

        <div className="flex items-center mb-4 justify-between gap-4">
          <span className="ml-3 text-white flex flex-col">
            <span className="text-base font-bold font-montserratBold">Ind. Wrapped in Cellophane Bags </span>
          </span>
          <label htmlFor="cellophaneBagsLabel" className="flex items-center cursor-pointer">
            <input
              id="cellophaneBagsLabel"
              data-testid="cellophane-bags-toggle"
              type="checkbox"
              className="sr-only"
              checked={cellophaneBags}
              onChange={(e) => handleCellophaneBagsChange(e.target.checked)}
            />
            <div className={`
              relative w-12 h-6 rounded-full transition-colors duration-300
              ${cellophaneBags ? 'bg-[#E01766]' : 'bg-[#800e3c]'}
            `}
            >
              <div className={`
                absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform duration-300
                ${cellophaneBags ? 'translate-x-6' : 'translate-x-0'}
              `}
              />
            </div>
          </label>
        </div>
      </div>

      {/* Ice Cream Option */}
      <div className="mb-8">
        <div className="flex items-center mb-4 justify-between gap-4">
          <span className="ml-3 text-white flex flex-col">
            <span className="text-base font-bold font-montserratBold">Would you like me to add ice cream to the order?</span>
          </span>
          <label htmlFor="iceCreamLabel" className="flex items-center cursor-pointer">
            <input
              id="iceCreamLabel"
              data-testid="ice-cream-toggle"
              type="checkbox"
              className="sr-only"
              checked={iceCream}
              onChange={(e) => handleIceCreamChange(e.target.checked)}
            />
            <div className={`
              relative w-12 h-6 rounded-full transition-colors duration-300
              ${iceCream ? 'bg-[#E01766]' : 'bg-[#800e3c]'}
            `}
            >
              <div className={`
                absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform duration-300
                ${iceCream ? 'translate-x-6' : 'translate-x-0'}
              `}
              />
            </div>
          </label>
        </div>

        {/* Ice Cream Description Text Box */}
        {iceCream && (
          <div className="mt-4 ml-3">
            <label
              htmlFor="iceCreamDescription"
              className="block text-sm font-medium text-white"
            >
              Please describe your ice cream preferences:
              <textarea
                id="iceCreamDescription"
                name="iceCreamDescription"
                className="w-full h-24 mt-2 px-4 py-3 border border-[#5A3770] rounded-lg bg-[#2C0C37] text-white placeholder-[#B4A5BB] focus:outline-none focus:ring-2 focus:ring-[#E01766] focus:border-transparent resize-none"
                placeholder="Let us know how much ice cream you would like and what flavors"
                value={iceCreamDescription}
                onChange={(e) => handleIceCreamDescriptionChange(e.target.value)}
              />
            </label>

          </div>
        )}
      </div>

      {errorMessage && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          {errorMessage}
        </div>
      )}

      <div className="flex gap-3">
        <button
          type="button"
          className="px-4 items-center justify-center  flex w-auto bg-transparent text-white text-center py-2 h-11 font-bold font-montserratBold border-[1px] border-solid border-[#F6F3F7]"
          onClick={() => {
            // Save current state before going back
            onFormDataChange({
              products,
              additionalProductRequests,
              waxBags,
              cellophaneBags,
              assortment,
              iceCream,
              iceCreamDescription
            });
            onBack();
          }}
        >
          Back
        </button>
        <button
          type="button"
          className={`
            dark:bg-button px-4 items-center justify-center  flex w-auto bg-button text-white text-center py-2 h-11 font-bold font-montserratBold
            ${totalCookies > 0
              ? 'bg-button text-white'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }
          `}
          onClick={handleNext}
          disabled={totalCookies === 0}
        >
          Next
        </button>
      </div>
    </div>
  );
};

Product.propTypes = {
  formData: PropTypes.shape({
    products: PropTypes.object,
    additionalProductRequests: PropTypes.string,
    waxBags: PropTypes.bool,
    cellophaneBags: PropTypes.bool,
    assortment: PropTypes.bool,
    iceCream: PropTypes.bool,
    iceCreamDescription: PropTypes.string
  }).isRequired,
  onFormDataChange: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default Product;
